import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay';
import { FollowSearchButton } from '../../components/global/FollowSearchButton/FollowSearchButton';
import { FormattedMessage } from 'react-intl';
import styles from './SbSharedFollowSearchBanner.scss';
import { trackFollowSearchBanner } from '../../utils/tracking/searchBrowse/trackFollowSearch';
import { locations } from '../../utils/tracking/shared/followSearchTracking';

const SbSharedFollowSearchBannerComponent = props => {
    const {
        user,
        uriRef,
        showFollowButton,
        isFollowing,
        followSearchValue,
        onFollowSearchCompleted,
    } = props;

    if (!showFollowButton) {
        return null;
    }

    return (
        <div data-tn="follow-search-banner" className={styles.container}>
            {isFollowing ? (
                <div className={styles.copy}>
                    <FormattedMessage
                        id="sb.FollowSearch.startedFollowingText"
                        defaultMessage="You are now following {name} and will receive a weekly email with new arrivals."
                        values={{
                            name: (
                                <span data-tn="follow-search-value" className={styles.searchTerm}>
                                    {followSearchValue}
                                </span>
                            ),
                        }}
                    />
                </div>
            ) : (
                <div>
                    <div className={styles.title}>
                        <FormattedMessage
                            id="sb.SbSharedFollowSearchBanner.title"
                            defaultMessage="Still looking?"
                        />
                    </div>
                    <div className={styles.copy}>
                        <FormattedMessage
                            id="sb.SbSharedFollowSearchBanner.text"
                            defaultMessage="Get weekly alerts when there are new arrivals for {name}"
                            values={{
                                name: (
                                    <span
                                        data-tn="follow-search-value"
                                        className={styles.searchTerm}
                                    >
                                        {followSearchValue}
                                    </span>
                                ),
                            }}
                        />
                    </div>
                </div>
            )}
            <FollowSearchButton
                size="medium"
                userId={get(user, 'serviceId') || null}
                user={user}
                page={uriRef}
                name={followSearchValue}
                onFollowSearchCompleted={() => {
                    trackFollowSearchBanner(isFollowing);
                    onFollowSearchCompleted();
                }}
                favoritesConnection={get(props, 'user.favorites') || null}
                location={locations.SEARCH_BROWSE}
            />
        </div>
    );
};

SbSharedFollowSearchBannerComponent.defaultProps = {
    onFollowSearchCompleted: () => {},
    isFollowing: false,
};

SbSharedFollowSearchBannerComponent.propTypes = {
    showFollowButton: PropTypes.bool.isRequired,
    isFollowing: PropTypes.bool.isRequired,
    followSearchValue: PropTypes.string,
    onFollowSearchCompleted: PropTypes.func,
    uriRef: PropTypes.string.isRequired,
    user: PropTypes.object,
};

export const SbSharedFollowSearchBanner = createFragmentContainer(
    SbSharedFollowSearchBannerComponent,
    {
        user: graphql`
            fragment SbSharedFollowSearchBanner_user on User {
                serviceId
                favorites(first: 1, types: $followSearchTypes, pages: $followSearchPages) {
                    ...FollowSearchButton_favoritesConnection
                }
            }
        `,
    }
);
